import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router';
import Ripple from 'components/common/Button/Ripple';

const propTypes = {
  tag: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  btnType: PropTypes.string,
  btnSize: PropTypes.string,
  btnColor: PropTypes.string,
  isLoading: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  center: PropTypes.bool,
  children: PropTypes.any,
};

const defaultProps = {
  tag: 'default',
};

class Button extends React.Component {
  constructor() {
    super();
    this.state = {
      cursorPos: {},
    };
    this.components = {
      default: 'button',
      link: Link,
      a: 'a',
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const cursorPos = {
      top: e.clientY,
      left: e.clientX,
      // Prevent component duplicates do ripple effect at the same time
      time: Date.now(),
    };
    this.setState({ cursorPos });
  }

  render() {
    const {
      btnType,
      btnSize,
      isLoading,
      isFullWidth,
      center,
      className,
      icon,
      ...rest
    } = this.props;
    const withRipple = btnType !== 'link';
    const btnClassName = cx({
      btn: true,
      [`btn--${btnType}`]: btnType,
      [`btn--${btnSize}`]: btnSize,
      'btn--loading': isLoading,
      'btn--width-full': isFullWidth,
      'btn--center': center,
      'ripple-parent': withRipple,
      [`${className}`]: className,
    });
    const Component = this.components[this.props.tag];
    const iconClassNames = cx({
      btn__icon: true,
      [`btn__icon--type-${icon}`]: icon,
    });

    return (
      <Component
        className={btnClassName}
        onMouseUp={this.handleClick}
        onTouchEnd={this.handleClick}
        {...rest}
      >
        {icon && <i className={iconClassNames} />}
        {this.props.children}
        {withRipple && <Ripple cursorPos={this.state.cursorPos} /> }
      </Component>
    );
  }
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
